import Avatar from '@mui/material/Avatar';
import { getSessionStorage } from "../utils/StorageUtil";
import { ACCOUNT_SO_KEY } from "../utils/accountUtils";

type Props = {
  diameter: number,
  borderSx?: string
};

const colors = [
  "#D29292",
  "#FA9F82",
  "#CE703C",
  "#D1CE75",
  "#E8CE49",
  "#BAA24C",
  "#AADA44",
  "#C5DD80",
  "#81A98A",
  "#9AC5B3",
  "#6BC9C9",
  "#00959E",
  "#8BB0F6",
  "#878BE3",
  "#6D6BBD",
  "#A5CFF0",
  "#5ECFF3",
  "#5ECFF3",
  "#DA7BCB",
  "#B972FF",
  "#A462BB",
  "#F399D5",
  "#B1418B",
  "#D15196"
]

function stringToColor(firstName: string, lastName: string) {
  const innitials = `${firstName[0]}${lastName[0]}`
  const index = (innitials.charCodeAt(0) - 65) + ((innitials.charCodeAt(1) - 65) / 5)
  return colors[Math.floor(index)]
}

function stringAvatar(firstName: string, lastName: string) {
  const innitials = `${firstName[0]}${lastName[0]}`
  return innitials;
}

export default function (props: Props) {
  const account = getSessionStorage(ACCOUNT_SO_KEY)
  const firstName = account.firstName
  const lastName = account.firstName
  return (
    <Avatar sx={{
      width: props.diameter,
      height: props.diameter,
      fontSize: props.diameter/2,
      border: props.borderSx,
      background: stringToColor(firstName, lastName)
    }}
    className='profile-avatar'
    children={stringAvatar(firstName, lastName)}/>
  );
}